import { PREFIX } from "./base";

export const DEFAULT_MEASURE_CANVAS_ID = `${PREFIX}_MEASURE_CANVAS_ID`;

export const DEFAULT_DATA_INDEX = `${PREFIX}_DEFAULT_DATA_INDEX`;

export const DEFAULT_DATA_KEY = `${PREFIX}_DEFAULT_DATA_KEY`;

export const DEFAULT_DATA_SERIES_FIELD = `${PREFIX}_DEFAULT_DATA_SERIES_FIELD`;

export const DEFAULT_SERIES_STYLE_NAME = `${PREFIX}_DEFAULT_SERIES_STYLE_NAME`;

export var AttributeLevel;

!function(AttributeLevel) {
    AttributeLevel[AttributeLevel.Default = 0] = "Default", AttributeLevel[AttributeLevel.Theme = 1] = "Theme", 
    AttributeLevel[AttributeLevel.Chart = 2] = "Chart", AttributeLevel[AttributeLevel.Base_Series = 3] = "Base_Series", 
    AttributeLevel[AttributeLevel.Series = 4] = "Series", AttributeLevel[AttributeLevel.Mark = 5] = "Mark", 
    AttributeLevel[AttributeLevel.User_Chart = 6] = "User_Chart", AttributeLevel[AttributeLevel.User_Series = 7] = "User_Series", 
    AttributeLevel[AttributeLevel.User_Mark = 8] = "User_Mark", AttributeLevel[AttributeLevel.User_SeriesStyle = 9] = "User_SeriesStyle", 
    AttributeLevel[AttributeLevel.Built_In = 99] = "Built_In";
}(AttributeLevel || (AttributeLevel = {}));

export const STACK_FIELD_KEY = `${PREFIX}_STACK_KEY`;

export const STACK_FIELD_START = `${PREFIX}_STACK_START`;

export const STACK_FIELD_END = `${PREFIX}_STACK_END`;

export const STACK_FIELD_START_PERCENT = `${PREFIX}_STACK_START_PERCENT`;

export const STACK_FIELD_END_PERCENT = `${PREFIX}_STACK_END_PERCENT`;

export const STACK_FIELD_START_OffsetSilhouette = `${PREFIX}_STACK_START_OffsetSilhouette`;

export const STACK_FIELD_END_OffsetSilhouette = `${PREFIX}_STACK_END_OffsetSilhouette`;

export const STACK_FIELD_TOTAL = `${PREFIX}_STACK_TOTAL`;

export const STACK_FIELD_TOTAL_PERCENT = `${PREFIX}_STACK_TOTAL_PERCENT`;

export const STACK_FIELD_TOTAL_TOP = `${PREFIX}_STACK_TOTAL_TOP`;

export const SEGMENT_FIELD_START = `${PREFIX}_SEGMENT_START`;

export const SEGMENT_FIELD_END = `${PREFIX}_SEGMENT_END`;

export var LayoutZIndex;

!function(LayoutZIndex) {
    LayoutZIndex[LayoutZIndex.Axis_Grid = 50] = "Axis_Grid", LayoutZIndex[LayoutZIndex.CrossHair_Grid = 100] = "CrossHair_Grid", 
    LayoutZIndex[LayoutZIndex.Region = 450] = "Region", LayoutZIndex[LayoutZIndex.Mark = 300] = "Mark", 
    LayoutZIndex[LayoutZIndex.Node = 400] = "Node", LayoutZIndex[LayoutZIndex.Axis = 100] = "Axis", 
    LayoutZIndex[LayoutZIndex.MarkLine = 500] = "MarkLine", LayoutZIndex[LayoutZIndex.MarkArea = 100] = "MarkArea", 
    LayoutZIndex[LayoutZIndex.MarkPoint = 500] = "MarkPoint", LayoutZIndex[LayoutZIndex.DataZoom = 500] = "DataZoom", 
    LayoutZIndex[LayoutZIndex.ScrollBar = 500] = "ScrollBar", LayoutZIndex[LayoutZIndex.Player = 500] = "Player", 
    LayoutZIndex[LayoutZIndex.Legend = 500] = "Legend", LayoutZIndex[LayoutZIndex.CrossHair = 500] = "CrossHair", 
    LayoutZIndex[LayoutZIndex.Indicator = 500] = "Indicator", LayoutZIndex[LayoutZIndex.Title = 500] = "Title", 
    LayoutZIndex[LayoutZIndex.Label = 500] = "Label", LayoutZIndex[LayoutZIndex.Brush = 500] = "Brush", 
    LayoutZIndex[LayoutZIndex.CustomMark = 500] = "CustomMark", LayoutZIndex[LayoutZIndex.Interaction = 700] = "Interaction";
}(LayoutZIndex || (LayoutZIndex = {}));

export var LayoutLevel;

!function(LayoutLevel) {
    LayoutLevel[LayoutLevel.Indicator = 10] = "Indicator", LayoutLevel[LayoutLevel.Region = 20] = "Region", 
    LayoutLevel[LayoutLevel.Axis = 30] = "Axis", LayoutLevel[LayoutLevel.DataZoom = 40] = "DataZoom", 
    LayoutLevel[LayoutLevel.Player = 40] = "Player", LayoutLevel[LayoutLevel.ScrollBar = 40] = "ScrollBar", 
    LayoutLevel[LayoutLevel.Legend = 50] = "Legend", LayoutLevel[LayoutLevel.Title = 70] = "Title", 
    LayoutLevel[LayoutLevel.CustomMark = 70] = "CustomMark";
}(LayoutLevel || (LayoutLevel = {}));

export const GradientType = [ "linear", "radial", "conical" ];

export const DEFAULT_LINEAR_GRADIENT_CONFIG = {
    x0: 0,
    y0: 0,
    x1: 1,
    y1: 1
};

export const DEFAULT_RADIAL_GRADIENT_CONFIG = {
    x0: 0,
    y0: 0,
    x1: 1,
    y1: 1,
    r0: 0,
    r1: 1
};

export const DEFAULT_CONICAL_GRADIENT_CONFIG = {
    x: .5,
    y: .5,
    startAngle: 0,
    endAngle: 2 * Math.PI
};

export const DEFAULT_GRADIENT_CONFIG = {
    linear: DEFAULT_LINEAR_GRADIENT_CONFIG,
    radial: DEFAULT_RADIAL_GRADIENT_CONFIG,
    conical: DEFAULT_CONICAL_GRADIENT_CONFIG
};

export * from "./base";

export * from "./label";

export * from "./polar";

export * from "./layout";

export * from "./event";

export * from "./waterfall";

export * from "./correlation";
//# sourceMappingURL=index.js.map